import { Select, Space, Typography } from 'antd'
import { useHistogramConfiguration } from 'features/drilldown/components/histogram/contexts/HistogramConfigurationContext'
import { PlotlyOrientation } from 'features/drilldown/components/histogram/plotlyGenerators'
import { FC } from 'react'

const { Text } = Typography

const ORIENTATION_OPTIONS: Array<{
  value: PlotlyOrientation
  label: string
}> = [
  { value: 'h', label: 'Horizontal' },
  { value: 'v', label: 'Vertical' },
]

export const HistoPlotConfigView: FC = () => {
  const { orientation, setOrientation, plotType, setPlotType } =
    useHistogramConfiguration()

  const isPlotConfigurable = !!setOrientation || !!setPlotType
  return (
    <>
      {isPlotConfigurable && (
        <Space
          style={{
            flexWrap: 'wrap',
            gap: '5px',
          }}>
          <Text strong>Plot:</Text>
          {!!setPlotType && (
            <Select
              prefix='Plot: '
              options={[
                { value: 'bar', label: 'Bar' },
                { value: 'pie', label: 'Pie' },
                { value: 'stacked', label: 'Stacked' },
              ]}
              value={plotType}
              onChange={setPlotType}
              style={{ width: 200 }}
            />
          )}
          {!!setOrientation && (
            <Select
              prefix='Orient: '
              options={ORIENTATION_OPTIONS}
              value={orientation}
              onChange={setOrientation}
              style={{ width: 200 }}
            />
          )}
        </Space>
      )}
    </>
  )
}
